import { shallow } from "zustand/shallow";
import { useUiStore } from "@core/stores/uiStore";
import LnbPc from "@core/layouts/lnb/LnbPc";
import LnbMobile from "@core/layouts/lnb/LnbMobile";

export default function Lnb() {
  const { isPcView, setIsCnbOpen } = useUiStore(
    (state) => ({
      isPcView: state.isPcView(),
      setIsCnbOpen: state.setIsCnbOpen,
    }),
    shallow,
  );

  return isPcView ? <LnbPc /> : <LnbMobile />;
}
